var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"media mb-2"},[_c('div',{staticClass:"icon mr-3"},[_c('i',{class:_vm.activity.icon})]),_c('div',{staticClass:"media-body"},[_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.activity.message))]),_c('small',{staticClass:"text-blue"},[_vm._v(_vm._s(_vm.activity.timestamp))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }